module.exports = __webpack_public_path__ + "img/card-default-large.438050df.png";